/*import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { catchError, from, mergeMap, Observable, tap, throwError } from 'rxjs';
import { Storage } from '@ionic/storage-angular';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private storage: Storage) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return from(this.storage.get('token')).pipe(
      mergeMap((token) => {
        // Verifica se um token foi armazenado
        if (token) {
          request = request.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`, // Formato correto do cabeçalho
            },
          });
        }

        return next.handle(request).pipe(
          // Log da resposta
          tap(event => {
            //console.log('Resposta recebida:', event);
          }),
          catchError((error) => {
            console.error('Erro no interceptor', error);
            // Adiciona mais detalhes sobre o erro
            if (error.status === 0) {
              console.error('Erro de rede ou CORS');
            } else if (error.status === 401) {
              console.error('Erro de autenticação: Token inválido ou expirado.');
            } else {
              console.error(`Erro ${error.status}: ${error.message}`);
            }
            return throwError(error); // Lança o erro para tratamento posterior
          })
        );
      })
    );
  }
}*/


import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, from, mergeMap, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Storage } from '@ionic/storage-angular';
import { StorageService } from '../services/storage-service/storage.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private storage: Storage,
    private storageService: StorageService
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Busca token e servidor sempre no momento da requisição
    return from(Promise.all([
      this.storage.get('token'),
      this.storageService.getServidor(),
      this.storage.get('tenant_id')
    ])).pipe(
      mergeMap(([token, servidor, tenant_id]) => {
        if (!servidor?.url_servidor) {
          console.error('Nenhuma URL de servidor configurada!');
          return throwError(() => new Error('Servidor não configurado'));
        }

        const baseUrl = servidor.url_servidor;

        // Se a requisição não tiver URL absoluta, prefixa com baseUrl
        let apiReq = request;
        if (!request.url.startsWith('http')) {
          apiReq = request.clone({ url: `${baseUrl}${request.url}` });
        }

        // 2. Monta os headers dinamicamente
        const headers: Record<string, string> = {};

        if (token) {
          headers['Authorization'] = `Bearer ${token}`;
        }

        if (tenant_id) {
          headers['X-Tenant-ID'] = tenant_id;
        }

        // 3. Aplica todos os headers de uma só vez (se houver algum)
        if (Object.keys(headers).length > 0) {
          apiReq = apiReq.clone({ setHeaders: headers });
        }
        

        return next.handle(apiReq).pipe(
          catchError((error) => {
            console.error('Erro no interceptor', error);
            if (error.status === 0) {
              console.error('Erro de rede ou CORS');
            } else if (error.status === 401) {
              console.error('Erro de autenticação: Token inválido ou expirado.');
            } else {
              console.error(`Erro ${error.status}: ${error.message}`);
            }
            return throwError(() => error);
          })
        );
      })
    );
  }
}
